import { render, staticRenderFns } from "./ImportResult.vue?vue&type=template&id=0710deb4&"
import script from "./ImportResult.vue?vue&type=script&lang=js&"
export * from "./ImportResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports